// extracted by mini-css-extract-plugin
module.exports = {"root":"e_Uib","heading":"e_Vib","text":"e_Wib","link":"e_Xib"};